import CategoryCard, { CategoryCardProps } from './CategoryCard';

export default CategoryCard;
export type { CategoryCardProps };
